import React, { useState,useEffect } from 'react'
import businessServices from './businessServices';


import BusinessForm from './BusinessForm';

import InlineImage from '../../components/InlineEdit/InlineImage';
import useSystemMasterList from '../../hooks/useSystemMasterList';

const BusinessDetails = ({label,value}) =>{
    return (
    <div className="row">
        <div className="col-md-6">
            <strong>{label}</strong>
        </div>
        <div className="col-md-6">
            <span>{value}</span>
        </div>
    </div>
    )
}


export default function BusinessComponent({userId}) {
    const [businessList, setBusinessList] = useState(null)
    const [loadingInProgress, setLoadingStatus] = useState(false);
    const [masters,getMasterLabel] = useSystemMasterList(['business-type'])

    

    const getBusinessList = () => {
        setLoadingStatus(true);
        businessServices.getListByUserId(userId).then(res => {
            res.data.length > 0 ? setBusinessList(res.data) : setBusinessList(null);
            setLoadingStatus(false);
        }).catch(error=>{
            setLoadingStatus(false);
        })
    }

    

    useEffect(() => {
        getBusinessList();
    }, [])

    return (
      <>
        {!loadingInProgress &&
            <div className=" mt-2" id="business">
                
                <div className="card-body">
                        {businessList &&
                            <>
                                {
                                    businessList.map(business => 
                                        <div key={business.id}>

                                            <div className="row" >
                                                <div className="col-md-3">
                                                    <InlineImage editId={business.id} name="logo" value={business.logo} handleInlineChange={businessServices.update}  />
                                                </div>
                                                <div className="col-md-9">
                                                    { /*
                                                        <InlineTextEdit editId={business.id}  name="title" 
                                                        handleInlineChange={businessServices.update}  
                                                        label="Business Name" value={business.title}  
                                                    />
                                                    <InlineTextEdit editId={business.id}  name="gst" 
                                                        handleInlineChange={businessServices.update}  
                                                        label="Business GST" value={business.gst}  
                                                    />
                                                    <InlineTextEdit editId={business.id}  name="pan" 
                                                        handleInlineChange={businessServices.update}  
                                                        label="Business PAN" value={business.pan}  
                                                    />
                                                    */}
                                                    <BusinessForm userId={userId} refreshList={getBusinessList} data={business}  masters={masters}/>
                                                    <BusinessDetails label="Business Name" value={business.title}/>
                                                    <BusinessDetails label="Business Owner" value={business.businessOwner}/>
                                                    <BusinessDetails label="Business GST" value={business.gst}/>
                                                    <BusinessDetails label="Business Pan" value={business.pan}/>
                                                    
                                                    <BusinessDetails label="Business Phone" value={business.businessPhone}/>
                                                    <BusinessDetails label="Business Email" value={business.businessEmail}/>
                                                    {masters &&  <BusinessDetails label="Business Type" value={getMasterLabel("business-type",business.businessType)}/>  }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        }

                        
                        {!businessList &&
                            <div className="row">
                                <div className="center"><h6>No Business Details Exist <BusinessForm userId={userId} refreshList={getBusinessList}  masters={masters}/> </h6></div>
                            </div>
                        }
                </div>
            </div>
        }
      </>
    )
}